import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiPaths } from '../../enums/api-paths';
import { RegistrationRequest } from '../../models/registration-request';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(
    private httpClient: HttpClient
  ) {}

  register(registrationRequest: RegistrationRequest): Observable<object> {
    return this.httpClient.post(
      ApiPaths.REGISTRATION_URL,
      registrationRequest,
      {
        withCredentials: true,
      }
    );
  }

  promoteToAdmin(userId: number): Observable<object> {
    return this.httpClient.patch(
      ApiPaths.PROMOTE_TO_ADMIN_URL+`/${userId}`,
      null,
      {
        withCredentials: true,
      }
    );
  }
}
